<template>
  <div>
    <div
      class="autocomplete-card"
      ref="autocomplete-card"
    >
      <div class="autocomplete-title">
        Search places
      </div>
      <div class="autocomplete-container">
        <input
          ref="autocomplete"
          class="autocomplete"
          placeholder="Enter a location"
          type="text"
          :value="searchString"
        />
      </div>
    </div>
    <div id="map-container" ref="map"></div>
    <div ref="infowindow-content" class="infowindow-content">
      <img v-if="infoWindowIconSrc" alt="icon" :src="infoWindowIconSrc" width="16" height="16">
      <span v-if="infoWindowPlaceName" ref="place-name" class="title">{{ infoWindowPlaceName }}</span>
      <br v-if="infoWindowIconSrc || infoWindowPlaceName" />
      <span ref="place-address">{{ infoWindowPlaceAddress }}</span>
    </div>
  </div>
</template>

<script>
import GoogleMapsLoader from 'google-maps'
import { mdbIcon } from 'mdbvue'

const API_KEY = 'AIzaSyCqSsnHrO976-Sr0GM3ZCVcOktKKpyCcb0'

export default {
  name: 'Bridge8GoogleMap',
  data () {
    return {
      id: null,
      map: null,
      marker: null,
      autocomplete: null,
      infoWindow: null,
      infoWindowIconSrc: null,
      infoWindowPlaceName: null,
      infoWindowPlaceAddress: null,
      google: null
    }
  },
  props: {
    point: Object,
    searchString: String
  },
  mounted () {
    this.id = this._uid
    GoogleMapsLoader.KEY = API_KEY
    GoogleMapsLoader.LIBRARIES = ['places']
    GoogleMapsLoader.VERSION = 'weekly'
    GoogleMapsLoader.LANGUAGE = navigator.language
    GoogleMapsLoader.load(google => {
      this.google = google
      const element = this.$refs['map']
      if (!element) {
        alert('No element!')
        return
      }
      const geocoder = new google.maps.Geocoder()
      const pickPointHandler = () => {
        this.infoWindow.close()
        const position = this.marker.getPosition()
        geocoder.geocode(
          { latLng: position },
          responses => {
            const description = responses && responses.length > 0
              ? responses[0].formatted_address
              : (function () {
                console.warn('Cannot determine address at this location.')
                return null
              }())
            this.infoWindowIconSrc = null
            this.infoWindowPlaceName = null
            this.infoWindowPlaceAddress = description
            this.infoWindow.open(this.map, this.marker)
            this.$emit(
              'pick-point',
              {
                latitude: position.lat(),
                longitude: position.lng(),
                description: description
              }
            )
          }
        )
      }

      const zeroLatLng = new google.maps.LatLng(0, 0)
      const options = {
        zoom: 7,
        center: zeroLatLng
      }
      this.map = new google.maps.Map(element, options)
      this.infoWindow = new google.maps.InfoWindow()
      this.infoWindow.setContent(this.$refs['infowindow-content'])
      this.marker = new google.maps.Marker({
        position: zeroLatLng,
        map: this.map,
        draggable: true
      })
      if (
        this.point &&
        this.point.latitude &&
        this.point.longitude
      ) {
        const positionLatLng = new google.maps.LatLng(
          this.point.latitude,
          this.point.longitude
        )
        this.map.setCenter(positionLatLng)
        this.marker.setPosition(positionLatLng)
        pickPointHandler()
      } else if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(position => {
          const geolocationLatLng = new google.maps.LatLng(
            position.coords.latitude,
            position.coords.longitude
          )
          this.map.setCenter(geolocationLatLng)
          this.marker.setPosition(geolocationLatLng)
          pickPointHandler()
        })
      }

      const card = this.$refs['autocomplete-card']
      this.map.controls[google.maps.ControlPosition.TOP_RIGHT].push(card)

      this.autocomplete =
        new google.maps.places.Autocomplete(this.$refs['autocomplete'])
      this.autocomplete.setFields(['geometry', 'icon', 'name', 'formatted_address'])
      this.autocomplete.bindTo('bounds', this.map)

      const autocompleteHandler = () => {
        this.marker.setVisible(false)
        this.infoWindow.close()
        const place = this.autocomplete.getPlace()

        if (!place.geometry) {
          if (this.$notify) {
            this.$notify.warn({
              title: 'Search failed.',
              message: `No details available for input: "${place.name}"`,
              position: 'top right',
              timeOut: 10000,
              closeButton: true
            })
          } else {
            console.warn(`No details available for input: "${place.name}"`)
          }
          return
        }

        if (place.geometry.viewport) {
          this.map.fitBounds(place.geometry.viewport)
        } else {
          this.map.setCenter(place.geometry.location)
          this.map.setZoom(16)
        }
        this.marker.setPosition(place.geometry.location)
        this.marker.setVisible(true)
        this.infoWindowIconSrc = place.icon
        this.infoWindowPlaceName = place.name
        this.infoWindowPlaceAddress = place.formatted_address
        this.infoWindow.open(this.map, this.marker)
        this.$emit(
          'pick-point',
          {
            latitude: place.geometry.location.lat(),
            longitude: place.geometry.location.lng(),
            description: (place.name !== '' ? `${place.name}: ` : '') + place.formatted_address
          }
        )
      }
      this.autocomplete.addListener('place_changed', autocompleteHandler)

      this.marker.addListener('dragend', pickPointHandler)
      this.map.addListener('click', event => {
        this.marker.setPosition(event.latLng)
        pickPointHandler()
      })
    })
  },
  components: {
    mdbIcon
  }
}
</script>

<style lang="sass">
.pac-container
  z-index: 10000 !important
</style>

<style lang="sass" scoped>
.infowindow-content
  display: none

#map-container
  height: 100%

  .infowindow-content
    display: inline

    .title
      font-weight: bold

.autocomplete-card
  margin: 10px 10px 0 0
  border-radius: 2px 0 0 2px
  box-sizing: border-box
  -moz-box-sizing: border-box
  outline: none
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.3)
  background-color: #fff

  .autocomplete-container
    padding-bottom: 12px
    padding-top: 12px
    margin-right: 12px

    .autocomplete
      background-color: #fff
      font-size: 15px
      font-weight: 300
      margin-left: 12px
      padding: 0 11px 0 13px
      text-overflow: ellipsis
      width: 400px

      &:focus
        border-color: #4d90fe

  .autocomplete-title
    color: #fff
    background-color: #4d90fe
    font-size: 18px
    font-weight: 500
    padding: 6px 12px

</style>



// WEBPACK FOOTER //
// src/components/Bridge8GoogleMap.vue